import { render, staticRenderFns } from "./ActiveImeiConfig.vue?vue&type=template&id=47d1e072&scoped=true&"
import script from "./ActiveImeiConfig.vue?vue&type=script&lang=js&"
export * from "./ActiveImeiConfig.vue?vue&type=script&lang=js&"
import style0 from "./ActiveImeiConfig.vue?vue&type=style&index=0&id=47d1e072&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d1e072",
  null
  
)

export default component.exports